// interfaces
import { CredPaymentMethod } from "@payment-ui/interfaces/CredPay";
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-types";
import { PaymentMethod, PaymentMethodMeta } from "@payment-ui/interfaces";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// helpers
import { getPaymentMethodPromoMsg, getPaymentMethodDisableMsg } from "@payment-ui/helpers/Payment";

export const getCredAriaLabel = (paymentMethodData: CredPaymentMethod, enabled: boolean): string => {
    const displayName = TEXTS.CRED;
    const getMsg = enabled ? getPaymentMethodPromoMsg : getPaymentMethodDisableMsg;
    return `${displayName} ${getMsg(paymentMethodData)}`;
};

export function isCredPaymentMethod(method: PaymentMethod<PaymentMethodMeta>): boolean {
    return [VALID_PAYMENT_GROUP_TYPES.CRED].indexOf(method.groupName.toUpperCase()) !== -1;
}
